var map = {
	"./actions-tray/feature": [
		25954,
		5954
	],
	"./assets/feature": [
		85284,
		5284
	],
	"./batching/feature": [
		20419,
		419
	],
	"./counterfactual/feature": [
		91389,
		4531,
		4818,
		9211,
		5201,
		8174,
		2677,
		6804,
		4441,
		9240,
		4934,
		7762,
		898,
		5298,
		8201,
		8524,
		1389
	],
	"./global-search/feature": [
		97802,
		7802
	],
	"./gtf/feature": [
		4828,
		8463,
		4828
	],
	"./hypernative/feature": [
		35985,
		5201,
		6804,
		9240,
		4934,
		3330
	],
	"./ledger/feature": [
		61681,
		1681
	],
	"./myAccounts/feature": [
		99722,
		5505,
		5702,
		9407,
		9722
	],
	"./nfts/feature": [
		35369,
		5840,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		5729,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		7990
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		61857,
		5363,
		5201,
		9211,
		4531,
		2677,
		6804,
		7848,
		8659,
		9240,
		7762,
		9607,
		550,
		8224,
		1857
	],
	"./security/feature": [
		12903,
		2677,
		5125,
		2903
	],
	"./spaces/feature": [
		10227,
		9211,
		2677,
		5909,
		106,
		5125,
		227
	],
	"./speedup/feature": [
		77363,
		5201,
		7363
	],
	"./spending-limits/feature": [
		21883,
		5454,
		9211,
		5201,
		8174,
		4531,
		2677,
		6804,
		7848,
		4441,
		749,
		5420,
		9240,
		4934,
		7762,
		898,
		9607,
		5298,
		550,
		8224,
		8201,
		7020,
		424,
		1883
	],
	"./stake/feature": [
		68574,
		8955,
		6193
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		21221,
		2148,
		1221
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		5363,
		374
	],
	"./tx-notes/feature": [
		89232,
		9232
	],
	"./wallet/feature": [
		37564,
		4872,
		7564
	],
	"./walletconnect/feature": [
		77439,
		1520,
		6847,
		7884,
		7439
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;